/* eslint-disable func-names */
import React from 'react';
import ReactDOM from 'react-dom';
import { PostHogProvider } from '@posthog/react';
import posthog from 'posthog-js';
import config from './config';

import './index.css';
import App from './App';

posthog.init(config.telemetry.token, {
  api_host: config.telemetry.host,
  capture_pageview: false,
  capture_pageleave: false,
  capture_dead_clicks: false,
  autocapture: false,
  advanced_disable_feature_flags: true,
  disable_session_recording: true,
});

window.addEventListener('pagehide', () => {
  posthog.capture(
    'salir_dom_pagehide',
    {
      ultima_url: window.location.href,
      fecha_salida: new Date().toISOString(),
    },
    { transport: 'sendBeacon', send_instantly: true },
  );
});

ReactDOM.render(
  <PostHogProvider client={posthog}>
    <App />
  </PostHogProvider>,
  document.getElementById('root'),
  document.addEventListener(
    'copy',
    function(event) {
      event.clipboardData.setData(
        'text/plain',
        'No se permite copiar en esta página web',
      );
      event.preventDefault();
    },
    false,
  ),
  document.addEventListener(
    'paste',
    function(event) {
      event.clipboardData.setData(
        'text/plain',
        'No se permite pegar en esta página web',
      );
      event.preventDefault();
    },
    false,
  ),
);
